import { Link } from 'react-router-dom';
import { AppIcon } from '../../components/AppIcon';

type SubjectCatalogItem = {
  code: string;
  title: string;
  subtitle: string;
  icon: string;
  tone: string;
  status: string;
  to?: string;
};

const subjects: readonly SubjectCatalogItem[] = [
  { code: 'MATH', title: 'Matematika', subtitle: 'Berhitung, memahami pola, dan menyelesaikan soal dengan caramu sendiri.', icon: '➗', tone: 'math', status: 'Bisa dipelajari', to: '/student/study-v2' },
  { code: 'ENG', title: 'English', subtitle: 'Mendengar, melihat gambar, membaca, berbicara, dan menulis.', icon: 'ABC', tone: 'english', status: 'Segera hadir' },
  { code: 'IPA', title: 'IPA', subtitle: 'Mengamati dan memahami sains di sekitar kita.', icon: '⚗', tone: 'science', status: 'Segera hadir' },
  { code: 'IPS', title: 'IPS', subtitle: 'Mengenal manusia, tempat, lingkungan, dan masyarakat.', icon: '🌏', tone: 'social', status: 'Segera hadir' },
  { code: 'AR', title: 'Bahasa Arab', subtitle: 'Mengenal bunyi, kosakata, membaca, dan pola kalimat dasar.', icon: 'ع', tone: 'arabic', status: 'Segera hadir' },
  { code: 'ID', title: 'Bahasa Indonesia', subtitle: 'Membaca, memahami isi bacaan, kosakata, dan menulis.', icon: '📖', tone: 'indo', status: 'Segera hadir' },
];

export function StudentSubjectsPage() {
  return (
    <div className="stack production-page">
      <header className="production-page__heading">
        <div><span className="page-kicker">PELAJARAN</span><h1>Pilih ruang belajarmu</h1><p className="muted">Buka pelajaran yang sudah tersedia. Pelajaran lain akan hadir bertahap.</p></div>
      </header>

      <section className="subject-catalog">
        {subjects.map((subject) => {
          const card = (
            <article className={`subject-catalog-card subject-catalog-card--${subject.tone}${subject.to ? ' subject-catalog-card--active' : ''}`}>
              <div className="subject-catalog-card__icon">{subject.icon}</div>
              <div className="subject-catalog-card__copy"><span>{subject.code}</span><h2>{subject.title}</h2><p>{subject.subtitle}</p></div>
              <div className={`availability-pill ${subject.to ? 'availability-pill--active' : ''}`}>{subject.status}</div>
              {subject.to ? <span className="subject-catalog-card__cta">Mulai belajar <AppIcon name="chevronRight" width={16} /></span> : <span className="subject-catalog-card__cta subject-catalog-card__cta--muted">Belum tersedia</span>}
            </article>
          );
          return subject.to ? <Link className="subject-catalog-link" to={subject.to} key={subject.code}>{card}</Link> : <div key={subject.code}>{card}</div>;
        })}
      </section>
    </div>
  );
}
